document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header-wrapper');
    const extraOffset = 24;

    function getScrollOffset() {
        return header.getBoundingClientRect().height + extraOffset;
    }

    const nav = document.querySelector('.inline-navigation__list');
    nav.addEventListener('click', e => {
        const link = e.target.closest('a.inline-navigation__link');
        if (!link) return;

        const href = link.getAttribute('href');
        
        if (href.startsWith('#')) {
            e.preventDefault();

            const targetId = href.slice(1);
            const targetEl = document.getElementById(targetId);
            if (targetEl) {
                const elementTop = targetEl.getBoundingClientRect().top + window.pageYOffset;

                const offsetPosition = elementTop - getScrollOffset();

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

                history.pushState(null, '', href);
            }
        }
    });
});
